/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EmissionDateCounts
 */
export interface EmissionDateCounts {
    /**
     * 
     * @type {Date}
     * @memberof EmissionDateCounts
     */
    date: Date;
}

/**
 * Check if a given object implements the EmissionDateCounts interface.
 */
export function instanceOfEmissionDateCounts(value: object): value is EmissionDateCounts {
    if (!('date' in value) || value['date'] === undefined) return false;
    return true;
}

export function EmissionDateCountsFromJSON(json: any): EmissionDateCounts {
    return EmissionDateCountsFromJSONTyped(json, false);
}

export function EmissionDateCountsFromJSONTyped(json: any, ignoreDiscriminator: boolean): EmissionDateCounts {
    if (json == null) {
        return json;
    }
    return {
        
        'date': (new Date(json['date'])),
    };
}

export function EmissionDateCountsToJSON(json: any): EmissionDateCounts {
    return EmissionDateCountsToJSONTyped(json, false);
}

export function EmissionDateCountsToJSONTyped(value?: EmissionDateCounts | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'date': value['date'].toISOString(),
    };
}

